<ng-container *ngIf="payoutForm" [formGroup]="payoutForm">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Set Site Price</ion-card-title>
      <div *ngIf="!siteComplete.priceCompleted(payoutForm.value)" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="siteComplete.priceCompleted(payoutForm.value)"> </curbnturf-checked>
    </ion-card-header>
    <ion-card-content>
      <p>
        Set a base price and if you&rsquo;d like to allow additional CurbNTurfers, you can charge an extra perks and
        other allowances to the site.
      </p>
      <h4>
        <strong>What do you want your price per night to be?</strong>
      </h4>
      <curbnturf-price [price]="price"> </curbnturf-price>
      <p>
        <em>What is the guest feedback deposit?</em> As a host, you want feedback to encourage new guest to your site.
        The deposit from the guest(s) encourages them to give feedback from their stay. At the end of the guest&rsquo;s
        stay, they&rsquo;ll receive a follow up message asking them to rate and provide feedback about their stay and
        the site. Once the guest has filled out this feedback they&rsquo;ll receive all the deposit back in the form of
        CurbNTurf Cash.
      </p>

      <p>
        <em>What is CurbNTurf Cash?</em> This is the transactional debits and credits internally on CurbNTurf. CurbNTurf
        Cash is designed to bring guest(s) back. Guest(s) will use their CurbNTurf Cash with future reservations helping
        bring more guests to you.
      </p>

      <h4>
        <strong> Do you want to offer a discounted price on weeknights? (excluding holidays) </strong>
      </h4>
      <p>We suggest starting with 50% off to encourage weeknight bookings.</p>
      <div class="icon-w-label listing">
        <div class="input-w-label listing element-container">
          <input
            [formControl]="weekdayDiscount"
            [containerElement]="weekdayDiscountError"
            id="weekdayDiscount"
            type="number"
            min="0"
            class="text-field-rounded-left w-input"
          />
          <div class="element-inner currency-rounded-right">
            <div class="element-bold">%</div>
          </div>
        </div>
        <div class="per-night">
          <label for="weekdayDiscount"> Discount for Sunday through Thursday bookings (excluding holidays) </label>
        </div>
      </div>
      <div
        #weekdayDiscountError="curbnturfDisplayValidationErrorsContainerRef"
        curbnturfDisplayValidationErrorsContainer
      ></div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Offer 50% off your first CurbNTurfer</ion-card-title>
      <div class="optional-rift-soft">Recommended</div>
    </ion-card-header>
    <ion-card-content>
      <p>
        Offering this discount can help you get your first booking (and first review) faster. The more positive reviews
        you get, the more likely you are to show up in our search results and have your site featured on our website.
      </p>
      <div class="landowner-center accordion">
        <div class="landowner-wrapper listing">
          <div
            (click)="updateNextReservationDiscount(0.5)"
            [ngClass]="{ active: nextReservationDiscount?.value === 0.5 }"
            class="cnt-button"
          >
            <div class="cnt-button-copy">Opt me in!</div>
          </div>
          <div
            (click)="updateNextReservationDiscount(0)"
            [ngClass]="{ active: nextReservationDiscount?.value === 0 }"
            class="cnt-button"
          >
            <div class="cnt-button-copy">No, Thanks!</div>
          </div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Extra Accommodations</ion-card-title>
      <div class="optional-rift-soft">Recommended</div>
    </ion-card-header>
    <ion-card-content>
      <h4>How many extra vehicles and tents can the site accommodate?</h4>
      <div class="price-section grid">
        <div class="icon-w-label grid element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <input
            id="extraParkingPrice"
            name="extraParkingPrice"
            type="number"
            min="0"
            data-test="amenity-parking-price"
            [formControl]="extraParking.controls.price"
            [containerElement]="extraParkingPriceError"
            class="text-field-rounded-right w-input"
          />
          <div class="per-night">
            <label for="extraParkingPrice"> per vehicle (not including towing vehicle) </label>
          </div>
        </div>

        <div class="axle-count">
          <input
            id="extraParkingCount"
            name="extraParkingCount"
            type="number"
            min="0"
            data-test="amenity-parking-count"
            [formControl]="extraParking.controls.count"
            [containerElement]="extraParkingCountError"
            class="text-field-rounded w-input"
          />
          <div class="text-block-18">
            <label for="extraParkingCount">vehicles allowed per site.</label>
          </div>
        </div>

        <div>
          <div
            #extraParkingPriceError="curbnturfDisplayValidationErrorsContainerRef"
            curbnturfDisplayValidationErrorsContainer
          ></div>
        </div>

        <div>
          <div
            #extraParkingCountError="curbnturfDisplayValidationErrorsContainerRef"
            curbnturfDisplayValidationErrorsContainer
          ></div>
        </div>
        <div class="icon-w-label grid element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <input
            id="extraTentPrice"
            name="extraTentPrice"
            type="number"
            min="0"
            data-test="amenity-tents-price"
            [formControl]="extraTent.controls.price"
            [containerElement]="extraTentPriceError"
            class="text-field-rounded-right w-input"
          />
          <div class="per-night">
            <label for="extraTentPrice">per tent</label>
          </div>
        </div>

        <div class="axle-count">
          <input
            id="extraTentCount"
            name="extraTentCount"
            type="number"
            min="0"
            data-test="amenity-tents-count"
            [formControl]="extraTent.controls.count"
            [containerElement]="extraTentCountError"
            class="text-field-rounded w-input"
          />
          <div class="text-block-18">
            <label for="extraTentCount">tents allowed per site.</label>
          </div>
        </div>

        <div>
          <div
            #extraTentPriceError="curbnturfDisplayValidationErrorsContainerRef"
            curbnturfDisplayValidationErrorsContainer
          ></div>
        </div>

        <div>
          <div
            #extraTentCountError="curbnturfDisplayValidationErrorsContainerRef"
            curbnturfDisplayValidationErrorsContainer
          ></div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Taxes</ion-card-title>
      <div class="optional-rift-soft">Optional</div>
    </ion-card-header>
    <ion-card-content>
      <curbnturf-listing-taxes [userId]="currentUser?.id" (saved)="savedPassThrough($event)"> </curbnturf-listing-taxes>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Firewood Bundle (A la Carte)</ion-card-title>
      <div class="optional-rift-soft">Optional</div>
    </ion-card-header>
    <ion-card-content>
      <div class="icon-w-label">
        <p>
          Give your CurbNTurfers a warm welcome by offering a bundle of firewood to be waiting at their site. There
          should be enough to set a fire to burn for at least 1 hour.
        </p>
        <div class="toggle-wrapper">
          <curbnturf-toggle [selected]="firewoodCount?.value > 0" (clicked)="toggleFirewood()"> </curbnturf-toggle>
        </div>
      </div>
      <ng-container *ngIf="firewoodCount?.value > 0">
        <div class="icon-w-label grid element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <input
            type="number"
            min="0"
            [formControl]="firewoodPrice"
            [containerElement]="firewoodPriceError"
            class="text-field-rounded-right w-input"
            id="firewood-price"
          />
          <div class="per-night">
            <label for="firewood-price">per bundle</label>
          </div>
        </div>
        <div
          #firewoodPriceError="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
        <p class="fine-print">Please enter a price to continue</p>
      </ng-container>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Offer Lessons (A la Carte)</ion-card-title>
      <div class="optional-rift-soft">Optional</div>
    </ion-card-header>
    <ion-card-content>
      <div class="icon-w-label">
        <p>
          Share your talent and skills with other CurbNTurfers. Give unique opportunities for guest to learn and develop
          valuable skills. Set the price per tour below.
        </p>
        <div class="toggle-wrapper">
          <curbnturf-toggle [selected]="lessonCount?.value > 0" (clicked)="toggleLesson()"> </curbnturf-toggle>
        </div>
      </div>
      <ng-container *ngIf="lessonCount?.value > 0">
        <div class="divider-line"></div>
        <div class="title">Lesson name</div>
        <input
          id="lessonName"
          type="text"
          class="text-input text-input-rounded w-input"
          [formControl]="lessonName"
          placeholder="e.g. Campfire cooking lessons, Dutch oven cooking lessons..."
        />
        <div class="title">
          <label for="lessonDescription">Description</label>
        </div>
        <textarea
          id="lessonDescription"
          [formControl]="lessonDescription"
          placeholder="e.g. Nothing says it it as good as Dutch oven cooking..."
          class="site-description w-input"
        ></textarea>
        <div class="icon-w-label grid element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <input
            id="lessonPrice"
            type="number"
            min="0"
            [formControl]="lessonPrice"
            [containerElement]="lessonPriceError"
            class="text-field-rounded-right w-input"
          />
          <div class="per-night">
            <label for="lessonPrice">per group</label>
          </div>
        </div>
        <div
          #lessonPriceError="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
        <p class="fine-print">Please enter a price to continue</p>
      </ng-container>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Meal (A la Carte)</ion-card-title>
      <div class="optional-rift-soft">Optional</div>
    </ion-card-header>
    <ion-card-content>
      <div class="icon-w-label">
        <p>
          Do you want to offer breakfast or another meal to your guests? Make sure and describe what the quantity means.
          Should a couple select one per person or per couple, should they select one per day or per visit?
        </p>
        <div class="toggle-wrapper">
          <curbnturf-toggle [selected]="mealCount?.value > 0" (clicked)="toggleMeal()"> </curbnturf-toggle>
        </div>
      </div>
      <ng-container *ngIf="mealCount?.value > 0">
        <div class="divider-line"></div>
        <div class="title">
          <label for="mealName">Meal name</label>
        </div>
        <input
          id="mealName"
          type="text"
          class="text-input text-input-rounded w-input"
          [formControl]="mealName"
          placeholder="e.g. Country style breakfast"
        />
        <div class="title">
          <label for="mealDescription">Description</label>
        </div>
        <textarea
          id="mealDescription"
          [formControl]="mealDescription"
          placeholder="e.g. Breakfast includes bacon, fresh eggs, pancakes, and homemade jam.  Please add one for each person and each day you will want breakfast (For a couple wanting two breakfasts: Select 4)"
          class="site-description w-input"
        ></textarea>
        <div class="icon-w-label grid element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <label for="mealPrice" class="sr-only">Meal Price per Meal</label>
          <input
            id="mealPrice"
            type="number"
            min="0"
            [formControl]="mealPrice"
            [containerElement]="mealPriceError"
            class="text-field-rounded-right w-input"
          />
          <div class="per-night">per meal</div>
        </div>
        <div
          #mealPriceError="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
        <p class="fine-print">Please enter a price to continue</p>
      </ng-container>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Custom/Other (A la Carte)</ion-card-title>
      <div class="optional-rift-soft">Optional</div>
    </ion-card-header>
    <ion-card-content>
      <div class="icon-w-label">
        <p>
          Enter anything you would like but make sure your name is descriptive and that you have a good description.
        </p>
        <div class="toggle-wrapper">
          <curbnturf-toggle [selected]="otherCount?.value > 0" (clicked)="toggleOther()"> </curbnturf-toggle>
        </div>
      </div>
      <ng-container *ngIf="otherCount?.value > 0">
        <div class="divider-line"></div>
        <div class="title">
          <label for="otherName">Name of the custom item.</label>
        </div>
        <input id="otherName" type="text" class="text-input text-input-rounded w-input" [formControl]="otherName" />
        <div class="title">
          <label for="otherDescription">Description</label>
        </div>
        <textarea
          id="otherDescription"
          [formControl]="otherDescription"
          placeholder="Give a description"
          class="site-description w-input"
        ></textarea>
        <div class="icon-w-label grid element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <label for="otherPrice" class="sr-only"> Other Price per experience </label>
          <input
            id="otherPrice"
            type="number"
            min="0"
            [formControl]="otherPrice"
            [containerElement]="otherPriceError"
            class="text-field-rounded-right w-input"
          />
          <div class="per-night">per experience</div>
        </div>
        <div
          #otherPriceError="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
        <p class="fine-print">Please enter a price to continue</p>
      </ng-container>
    </ion-card-content>
  </ion-card>

  <ng-container *ngFor="let additionalOther of additionalOthers; let i = index">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Custom/Other (A la Carte) - {{ i + 2 }}</ion-card-title>
        <div class="optional-rift-soft">Optional</div>
      </ion-card-header>
      <ion-card-content>
        <div class="icon-w-label">
          <p>
            Enter anything you would like but make sure your name is descriptive and that you have a good description.
          </p>
          <div class="toggle-wrapper">
            <curbnturf-toggle
              [selected]="additionalOther?.get('count')?.value > 0"
              (clicked)="toggleAdditionalOther(i)"
            >
            </curbnturf-toggle>
          </div>
        </div>
        <ng-container *ngIf="additionalOther?.get('count')?.value > 0">
          <div class="divider-line"></div>
          <div class="title">
            <label for="additionalOtherName">Name of the custom item.</label>
          </div>
          <input
            id="additionalOtherName"
            type="text"
            class="text-input text-input-rounded w-input"
            [formControl]="additionalOther?.get('name')"
          />
          <div class="title">
            <label for="additionalOtherDescription">Description</label>
          </div>
          <textarea
            id="additionalOtherDescription"
            [formControl]="additionalOther?.get('description')"
            placeholder="Give a description"
            class="site-description w-input"
          ></textarea>
          <div class="icon-w-label grid element-container">
            <div class="element-inner currency-rounded-left">
              <div class="element-bold">$</div>
            </div>
            <label for="additionalOtherPrice" class="sr-only"> Additional Item Price per experience </label>
            <input
              id="additionalOtherPrice"
              type="number"
              min="0"
              [formControl]="additionalOther?.get('price')"
              [containerElement]="additionalOtherPriceError"
              class="text-field-rounded-right w-input"
            />
            <div class="per-night">per experience</div>
          </div>
          <div
            #additionalOtherPriceError="curbnturfDisplayValidationErrorsContainerRef"
            curbnturfDisplayValidationErrorsContainer
          ></div>
          <p class="fine-print">Please enter a price to continue</p>
        </ng-container>
      </ion-card-content>
    </ion-card>
  </ng-container>

  <div class="bottom-button-wrapper listing">
    <a (click)="addAdditionalOther()" class="cnt-button filter w-inline-block">
      <div class="cnt-button-copy">Add another extra</div>
    </a>
  </div>
</ng-container>
